export const Role = {
  ANY: 0,
  EJECUTIVO_DE_VENTAS: 1,
  PRESUPUESTISTA: 2,
  PLANEACION: 3,
  ADMINISTRADOR: 4,
};

export const DESCRIPCION_EJECUTIVO_QUE_COTIZA = 'Ejecutivos que cotizan';

const { ANY, EJECUTIVO_DE_VENTAS, PRESUPUESTISTA, PLANEACION, ADMINISTRADOR } = Role;

export const RolesProspectos = [ADMINISTRADOR, EJECUTIVO_DE_VENTAS];
export const RolesSolicitudes = [ADMINISTRADOR, EJECUTIVO_DE_VENTAS, PRESUPUESTISTA];
export const RolesCotizaciones = [ADMINISTRADOR, PRESUPUESTISTA];
export const RolesPropuestas = [ADMINISTRADOR, EJECUTIVO_DE_VENTAS];
export const RolesOrdenesTrabajo = [ADMINISTRADOR, PRESUPUESTISTA];
export const RolesEspecificacionesTecnicas = [ADMINISTRADOR, PRESUPUESTISTA];
export const RolesCilindros = [ADMINISTRADOR, PRESUPUESTISTA];
export const RolesSuajes = [ADMINISTRADOR, PRESUPUESTISTA];
export const RolesConfiguracion = [ADMINISTRADOR];
export const RolesResource = [ADMINISTRADOR];
export const RolesReports = [ADMINISTRADOR, EJECUTIVO_DE_VENTAS, ANY];
export const RolesUsers = [ADMINISTRADOR];
export const RolesPallet = [ADMINISTRADOR, PLANEACION];
export const RolesMonitor = [ADMINISTRADOR, PLANEACION, ANY, EJECUTIVO_DE_VENTAS, PRESUPUESTISTA];
export const tieneAcceso = (roles, usuario) => {
  if (!roles.length) {
    return true;
  }
  if (usuario.roles.some((rol) => roles.includes(rol.Codigo) || rol.Codigo === ADMINISTRADOR)) {
    return true;
  }
};
